import { BiChevronDown } from 'react-icons/bi'

import { SquircleAdapter } from '../SquircleAdapter'

import { useBreakpoints } from '@/hooks'
import './styles.scss'

export interface IFaqQuestionProps {
  question: string
  answer: string
  isOpen: boolean
  onClick: () => void
  questionId: string
}

const FaqQuestion = ({
  question,
  answer,
  isOpen,
  onClick,
  questionId,
}: IFaqQuestionProps) => {
  const { isSemiMedium } = useBreakpoints()
  const answerId = `faq-answer-${questionId}`

  return (
    <div className="faq-question-wrapper-outer">
      <SquircleAdapter
        className="faq-question-wrapper"
        data-open={isOpen}
        cornerRadius={20}
      >
        {/* O heading fica por fora do botão, e não dentro: título aninhado em
            conteúdo interativo some da navegação por títulos do leitor de tela
            — justamente como se percorre um FAQ. Também torna a pergunta
            elegível a featured snippet. */}
        <h3 className="faq-question-heading">
          <button
            type="button"
            id={questionId}
            className="faq-question-container"
            onClick={onClick}
            aria-expanded={isOpen}
            aria-controls={answerId}
          >
            <BiChevronDown
              size={isSemiMedium ? 32 : 40}
              className="toggle-icon"
              data-open={isOpen}
              color="var(--primary)"
              aria-hidden
            />
            <span>{question}</span>
          </button>
        </h3>

        {/* A resposta sai de dentro do botão: antes era anunciada como parte do
            rótulo dele. O `visibility: hidden` do CSS já a remove da árvore de
            acessibilidade quando fechada, sem precisar de aria-hidden. */}
        <div
          id={answerId}
          className="content"
          data-open={isOpen}
          role="region"
          aria-labelledby={questionId}
        >
          {answer}
        </div>
      </SquircleAdapter>
    </div>
  )
}

export { FaqQuestion }
